import api from '../../redux/api';
import { SELLER_V1_BASE } from './constants';

export const sellerCustomersService = {
  getCustomers: async (params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/customers`, { params });
    return response.data;
  },

  getCustomer: async (customerId) => {
    const response = await api.get(`${SELLER_V1_BASE}/customers/${customerId}`);
    return response.data;
  },

  getCustomerTransactions: async (customerId, params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/customers/${customerId}/transactions`, { params });
    return response.data;
  },

  getCustomerPoints: async (customerId) => {
    const response = await api.get(`${SELLER_V1_BASE}/customers/${customerId}/points`);
    return response.data;
  },

  createCustomer: async (customerData) => {
    const response = await api.post(`${SELLER_V1_BASE}/customers`, customerData);
    return response.data;
  },

  updateCustomer: async (customerId, customerData) => {
    const response = await api.put(`${SELLER_V1_BASE}/customers/${customerId}`, customerData);
    return response.data;
  },

  // searchCustomers: async (params = {}) => (await api.get(`${SELLER_V1_BASE}/customers/search`, { params })).data,
  searchCustomers: async (params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/customers/search`, { params });
    return response.data;
  },

  getCustomerStats: async () => {
    const response = await api.get(`${SELLER_V1_BASE}/customers/stats`);
    return response.data;
  },

  // ==================== Email Messaging ====================
  getEmailTemplates: async (params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/email-templates`, { params });
    return response.data;
  },

  getEmailTemplate: async (templateId) => {
    const response = await api.get(`${SELLER_V1_BASE}/email-templates/${templateId}`);
    return response.data;
  },

  createEmailTemplate: async (templateData) => {
    const response = await api.post(`${SELLER_V1_BASE}/email-templates`, templateData);
    return response.data;
  },

  updateEmailTemplate: async (templateId, templateData) => {
    const response = await api.put(`${SELLER_V1_BASE}/email-templates/${templateId}`, templateData);
    return response.data;
  },

  deleteEmailTemplate: async (templateId) => {
    const response = await api.delete(`${SELLER_V1_BASE}/email-templates/${templateId}`);
    return response.data;
  },

  sendMessageToCustomers: async (data) => {
    const response = await api.post(`${SELLER_V1_BASE}/customers/message`, data);
    return response.data;
  },

  getEmailLogs: async (params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/email-logs`, { params });
    return response.data;
  },

  getEmailRateLimit: async () => {
    const response = await api.get(`${SELLER_V1_BASE}/email-rate-limit`);
    return response.data;
  },
};

export default sellerCustomersService;
